<div class="container-fluid py-3">
  <div class="mb-3">
    <h3 class="mb-1">{{ 'i18n.domain.analytics.periodic-statistics.title' | translate }}</h3>
    <p class="text-body-secondary mb-0">{{ 'i18n.domain.analytics.periodic-statistics.subtitle' | translate }}</p>
  </div>

  <div class="row align-items-center mb-3">
    <div class="col-auto">
      <label class="form-label mb-0" for="periodic-statistics-vehicle-id">{{ 'i18n.domain.analytics.periodic-statistics.vehicle-id' | translate }}</label>
    </div>
    <div class="col-auto">
      <input id="periodic-statistics-vehicle-id" type="number" class="form-control" min="1" [(ngModel)]="vehicleId" />
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" type="button" [disabled]="!vehicleId() || isLoading()" (click)="onLoad()">
        {{ 'i18n.domain.analytics.periodic-statistics.load' | translate }}
      </button>
    </div>
  </div>

  @if (statistics().length === 0) {
    <div class="card">
      <div class="card-body">
        <p class="text-body-secondary mb-0">{{ 'i18n.domain.analytics.periodic-statistics.empty' | translate }}</p>
      </div>
    </div>
  } @else {
    <pre>{{ statistics() | json }}</pre>
  }
</div>
